
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/groupPurchases/payment/wallet",
      function () {
        return require("private-next-pages/groupPurchases/payment/wallet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/groupPurchases/payment/wallet"])
      });
    }
  